const cryptoShuffle = require('crypto-shuffle');

const Card = require('./Card');

/**
 * 	 Class representing a Deck of Cards
 *
 *
 */
class Deck {
	constructor(cards = []) {
		this._cards = cards;
	}

	/**
	 * Generates 52 cards, 13 ranks of each suit into the deck
	 */
	generateCards() {
		for (let suit in Card.SUITS) {
			for (let rank in Card.RANKS) {
				this.addCard(new Card(rank, suit));
			}
		}
	}

	/**
	 * Gets a card by it's short name
	 * @param  {String} name e.g. AH, 2D, TC, KS
	 * @return {Card} card instance
	 */
	card(name) {
		return this._cards.find((card) => card.name == name);
	}

	/**
	 * Adds a card to the deck
	 * @private
	 * @param {Card} card
	 */
	addCard(card) {
		//TODO: check not duplicated
		this._cards.push(card);
		Object.defineProperty(this, `card${card.name}`, {
			get: () => {
				return this.card(card.name);
			},
		});
	}

	/**
	 * String representation of the deck,
	 * a full deck could be `2C3C4C5C6C7C8C9CTCJCQCKCAC2D3D4D5D6D7D8D9DTDJDQDKDAD2H3H4H5H6H7H8H9HTHJHQHKHAH2S3S4S5S6S7S8S9STSJSQSKSAS`
	 * @return {String} concatenation  of the string values of each card in the deck
	 */
	toString() {
		let str = this._cards.reduce((acc, card) => acc + card.toString(), '');
		return str;
	}

	/**
	 * In-place shuffle of the current list of Cards in the deck
	 * ```
	 * deck.shuffle(); // `deck.cards` is now shuffled
	 * ```
	 *
	 * @return {Card[]} returns the shuffled list of cards
	 */
	shuffle() {
		return cryptoShuffle(this.cards);
	}

	/**
	 * The current list of cards in the deck
	 * @return {Card[]}
	 */
	get cards() {
		return this._cards;
	}
}

/**
 * Generates a new deck of 52 cards
 * @return {Deck} - a fresh, unshuffled deck of 52 cards
 */
Deck.generate = () => {
	/**
	 * @lends Deck
	 * @type {Deck}
	 */
	let deck = new Deck();
	deck.generateCards();
	return deck;
};

module.exports = Deck;
